import BreadCrumbStyles from '../../styles/elements/BreadCrumbStyles.module.scss';
import Link from 'next/link';

import Breadcrumbs from '@marketsystems/nextjs13-appdir-breadcrumbs';

const BreadCrumbs = ({ hideLink }) => {
  return (
    <div className={BreadCrumbStyles.strip}>
      <div className={BreadCrumbStyles.container}>
        <div id={hideLink == true ? 'hiddenlink' : ''}>
          <Breadcrumbs useDefaultStyle={true} inactiveItemClassName={'disabled'} rootLabel="home" />
        </div>
      </div>
    </div>
  );
};



export default BreadCrumbs;
